export interface HasBoundingClientRect {
  readonly getBoundingClientRect: () => ClientRect;
}

export interface HasClientLocation {
  readonly clientX: number;
  readonly clientY: number;
}

export function coordsInsideRectangle(x: number, y: number, rect: ClientRect): boolean {
  return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
}

export function mouseIsOutsideRectangle(location: HasClientLocation, rect: ClientRect): boolean {
  return !coordsInsideRectangle(location.clientX, location.clientY, rect);
}

export function mouseIsOutsideElement(location: HasClientLocation, element: HasBoundingClientRect): boolean {
  if (element) {
    return mouseIsOutsideRectangle(location, element.getBoundingClientRect());
  } else {
    return true;
  }
}

export function mouseIsInsideElement(location: HasClientLocation, element: HasBoundingClientRect): boolean {
  return !mouseIsOutsideElement(location, element);
}
